<template>
  <div :class="fullscreen ? 'overlay' : ''">
    <div :class="['spinner', spinnerClass]"></div>
  </div>
</template>

<script>
/**
 *  Универсальный компонент, отвечающий за отображение лоудера
 *  в момент подгрузки данных с сервера.
 */
export default {
  name: 'Spinner',
  /**
   *  Передавая в данный компонент свойство fullscreen со значением true,
   *  возможно рендерить блок, закрывающий собой основной контент на время ожидания ответа от сервера,
   *  то есть такой блок будет всегда центрироваться по вертикали и горизонтали.
   */
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    spinnerClass: {
      type: String,
      default: 'spinner_md'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Spinner.vue